import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'report-';

export default {
    path: '/carbon',
    name: 'carbon',
    redirect: {
        name: `${pre}integral`
    },
    meta,
    component: BasicLayout,
    children: [
        // 青碳行
        {
            path: 'integral',
            name: `${pre}integral`,
            meta: {
                ...meta,
                title: '积分',
                closable: true
            },
            component: () => import('@/pages/carbon/integral')
        },
        {
            path: 'exchange',
            name: `${pre}exchange`,
            meta: {
                ...meta,
                title: '兑换',
                closable: true
            },
            component: () => import('@/pages/carbon/exchange')
        },
        {
            path: 'wallet',
            name: `${pre}wallet`,
            meta: {
                ...meta,
                title: '钱包',
                closable: true
            },
            component: () => import('@/pages/carbon/wallet')
        },
        {
            path: 'bubble',
            name: `${pre}bubble`,
            meta: {
                ...meta,
                title: '气泡',
                closable: true
            },
            component: () => import('@/pages/carbon/bubble')
        },
        // 沪碳行
        {
            path: 'integral-sh',
            name: `${pre}integral-sh`,
            meta: {
                ...meta,
                title: '积分',
                closable: true
            },
            component: () => import('@/pages/carbon/integral-sh')
        },
        {
            path: 'exchange-sh',
            name: `${pre}exchange-sh`,
            meta: {
                ...meta,
                title: '兑换',
                closable: true
            },
            component: () => import('@/pages/carbon/exchange-sh')
        },
        {
            path: 'wallet-sh',
            name: `${pre}wallet-sh`,
            meta: {
                ...meta,
                title: '钱包',
                closable: true
            },
            component: () => import('@/pages/carbon/wallet-sh')
        },
        {
            path: 'bubble-sh',
            name: `${pre}bubble-sh`,
            meta: {
                ...meta,
                title: '气泡',
                closable: true
            },
            component: () => import('@/pages/carbon/bubble-sh')
        },
    ]
};
